<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>visibility</v-icon>SEGUIMIENTO PLANILLA DETALLE
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="px-2">
          <v-layout row wrap class="text-xs-center blue--text">
            <v-flex xs12
              ><b
                >{{ this.form.ap_paterno }} {{ this.form.ap_materno }}
                {{ this.form.nombres }}</b
              ></v-flex
            >
            <v-flex shrink> <b> GESTIÓN:</b> {{ this.form.gestion }} </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink><b> MES:</b> {{ this.form.mes }} </v-flex>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="l_seguimiento"
                class="elevation-1"
                :no-data-text="
                  loading ? 'Cargando...' : 'No se tiene registros'
                "
                :loading="loading"
                item-key="index"
                rows-per-page-text="Filas por pagina"
                :pagination.sync="pagination"
              >
                <template v-slot:headers="props">
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        pagination.descending ? 'desc' : 'asc',
                        header.value === pagination.sortBy ? 'active' : ''
                      ]"
                      id="cabecera_tabla"
                      @click="changeSort(header.value)"
                    >
                      <v-icon small color="white">arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item._created_at).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ $moment(props.item._created_at).format("HH:mm") }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.usuario.nombre_usuario }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.cerrado ? "CERRADO" : "ABIERTO" }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.motivo }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
export default {
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      valid: true,
      form: {},
      dialog: false,
      loading: false,
      user: this.$storage.get("user"),
      l_seguimiento: [],
      // Variables tabla
      pagination: {
        sortBy: ""
      },
      headers: [
        {
          text: "Fecha",
          value: "_created_at",
          align: "center"
        },
        {
          text: "Hora",
          value: "_created_at",
          align: "center"
        },
        {
          text: "Usuario",
          value: "usuario",
          align: "center"
        },
        {
          text: "Acción",
          value: "cerrado",
          align: "center"
        },
        {
          text: "Justificación",
          value: "motivo",
          align: "center"
        }
      ],
      loading: false
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerSeguimientoPlanilla", async item => {
      this.form = item;
      this.dialog = true;
      await this.listaSegumiento();
    });
  },
  methods: {
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    // Metodo para listar el seguimiento
    async listaSegumiento() {
      this.loading = true;
      try {
        let rpta = await this.$service.graphql({
          query: `
            query{
              seguimientoPlanillas(gestion:${this.form.gestion},mes:${this.form.mes},id_persona: ${this.form.id_persona}){
                rows{
                  mes
                  gestion
                  cerrado
                  id_persona
                  motivo
                  _user_created
                  _created_at
                }
              }
          }
        `
        });
        let lista_tmp = rpta.seguimientoPlanillas.rows;
        for (let index = 0; index < lista_tmp.length; index++) {
          const element = lista_tmp[index];
          let rpta = await this.$service.graphql({
            query: `
            query{
              usuario(id:${element._user_created}){
                nombre_usuario
              }
            }
          `
          });
          element.usuario = rpta.usuario ? rpta.usuario : {};
        }
        this.l_seguimiento = lista_tmp;
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
    close() {
      this.loading = false;
      this.dialog = false;
      this.$bus.$emit("closeDialogVerSeguimientoPlanilla");
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/dialogs/VerSeguimientoPlanilla.vue